import { useCallback } from 'react'

const useScrollToTop = ref => {
    
    return useCallback((smooth = true) => {
        
        ref.current?.scroll({
            top: 0,
            behavior: smooth ? 'smooth' : 'auto',
        })
        
    }, [ref])
    
}

export default useScrollToTop
